module.exports = __webpack_public_path__ + "img/icon_pingbao.50ab116c.png";